import styled from 'styled-components'
import { theme } from 'styled-tools'

export const WrapperSummaryItem = styled.div`
  align-items: center;
  gap: ${theme('space.default')};
`
